// extracted by mini-css-extract-plugin
module.exports = {"current-area-search-wrapper":"_8c559fa4c7--current-area-search-wrapper--Z4lBY","current-area-search-text":"_8c559fa4c7--current-area-search-text--rk8uY"};